// src/components/TaskModal/TaskModal.jsx
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectModalMode,
  selectActiveTask,
  closeModal,
  createTask,
  updateTask,
  deleteTask,
} from '../../store/slices/tasksSlice.js';
import TaskForm from './TaskForm.jsx';

export default function TaskModal() {
  const dispatch = useDispatch();
  const mode = useSelector(selectModalMode);
  const task = useSelector(selectActiveTask);

  const isOpen = mode === 'create' || mode === 'edit';

  // Escape key to close
  useEffect(() => {
    if (!isOpen) return;
    const handler = (e) => { if (e.key === 'Escape') dispatch(closeModal()); };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [isOpen, dispatch]);

  if (!isOpen) return null;

  const title = mode === 'create' ? 'New Task' : 'Edit Task';
  const submitLabel = mode === 'create' ? 'Create Task' : 'Save Changes';

  const handleSubmit = (values) => {
    if (mode === 'create') {
      dispatch(createTask(values));
    } else {
      dispatch(updateTask({ ...task, ...values }));
    }
  };

  const handleDelete = mode === 'edit' && task
    ? () => dispatch(deleteTask(task.id))
    : undefined;

  return (
    <div
      className="modal-overlay"
      onClick={(e) => { if (e.target === e.currentTarget) dispatch(closeModal()); }}
      role="dialog"
      aria-modal="true"
      aria-label={title}
    >
      <div className="modal">
        <div className="modal-header">
          <div className="modal-title">{title}</div>
          <button
            className="btn btn-ghost btn-icon"
            onClick={() => dispatch(closeModal())}
            aria-label="Close modal"
          >
            ×
          </button>
        </div>

        <TaskForm
          initial={task || {}}
          onSubmit={handleSubmit}
          onCancel={() => dispatch(closeModal())}
          submitLabel={submitLabel}
          onDelete={handleDelete}
        />
      </div>
    </div>
  );
}
